module.exports = __webpack_public_path__ + "img/sakhonnakhon-phattana-waterAll.e78e5111.png";